'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var purple={1:'#f7f5ff',2:'#e3dbff',3:'#ccbdfe',4:'#bca9fa',5:'#9375f2',6:'#8956f0',7:'#683ac8',8:'#532ca6',9:'#3f1c86',10:'#2a1359',inflection:6};exports.default=(0,_createColorPalette2.default)(purple,'purple');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/purple.js
 **/